import type { ComponentProps, FC, ReactNode } from "react";

import { Button } from "./button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "./dropdown-menu";
import { Icon, type MaterialSymbol } from "./icon";
import { Spinner } from "./loading";
import { Tooltip, TooltipContent, TooltipTrigger } from "./tooltip";

export interface MoreMenuProps {
  buttonProps?: ComponentProps<typeof Button>;
  children: ReactNode;
  className?: string;
  icon?: MaterialSymbol;
  side?: ComponentProps<typeof DropdownMenuContent>["side"];
  align?: ComponentProps<typeof DropdownMenuContent>["align"];
  dropdownMenuProps?: ComponentProps<typeof DropdownMenu>;
  dropdownMenuContentProps?: ComponentProps<typeof DropdownMenuContent>;
  isLoading?: boolean;
  tooltip?: ReactNode;
}

export const MoreMenu: FC<MoreMenuProps> = ({
  buttonProps,
  children,
  icon = "more_horiz",
  side = "bottom",
  align = "end",
  dropdownMenuProps,
  dropdownMenuContentProps,
  isLoading,
  tooltip,
}) => {
  const trigger = (
    <DropdownMenuTrigger asChild>
      <Button
        variant="ghost"
        size="xs"
        display="icon"
        onClick={(e) => e.stopPropagation()}
        disabled={isLoading}
        {...buttonProps}
      >
        {isLoading ? <Spinner /> : <Icon icon={icon} className="font-bold" />}
      </Button>
    </DropdownMenuTrigger>
  );

  return (
    <DropdownMenu {...dropdownMenuProps}>
      {tooltip ? (
        <Tooltip>
          <TooltipTrigger asChild>{trigger}</TooltipTrigger>
          <TooltipContent>{tooltip}</TooltipContent>
        </Tooltip>
      ) : (
        trigger
      )}
      <DropdownMenuContent align={align} side={side} {...dropdownMenuContentProps}>
        {children}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
